import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { GdoVehicleContainerComponent } from './gdo-vehicle-container/gdo-vehicle-container.component';
import { GdoVehicleDetailComponent } from './gdo-vehicle-detail/gdo-vehicle-detail.component';
import { GdoEditSubscriberContactInformationComponent } from './gdo-vehicle-detail/gdo-edit-subscriber-contact-information/gdo-edit-subscriber-contact-information.component';
import { GdoManageSubscriptionComponent } from './gdo-vehicle-detail/gdo-manage-subscription/gdo-manage-subscription.component';

const routes: Routes = [
  {
    path:'',
    component:GdoVehicleContainerComponent,
    children:[
      {
        /*
        default! 
        URL: HOST/gdo-product
        */
        path:'',
        component:GdoVehicleDetailComponent, 
      },
      {
        /*
        URL: my-vehicle/subscriber-contact-info
        */
        path:'subscriber-contact-info', 
        component:GdoEditSubscriberContactInformationComponent
      },
      {
        path:'manage-billing',
        /*
        URL: my-vehicle/manage-billing
        */
        component: GdoManageSubscriptionComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GdoVehicleRoutingModule { }
